import { registerPostRender } from '../core/render.js';

let activeRafs = [];

export function initCountdowns() {
    // Cancelar loops anteriores de re-renders previos
    activeRafs.forEach(id => cancelAnimationFrame(id));
    activeRafs = [];

    document.querySelectorAll('.countdown-display').forEach(el => {
        const targetStr = el.getAttribute('data-target');
        if (!targetStr) return;
        const target = new Date(targetStr).getTime();
        const pad = n => String(Math.max(0, n)).padStart(2, '0');
        
        const update = () => {
            const diff = target - Date.now();
            if (diff <= 0) {
                el.querySelectorAll('.cd-num').forEach(n => n.textContent = '00');
                return;
            }
            const units = {
                d: Math.floor(diff / 86400000),
                h: Math.floor((diff % 86400000) / 3600000),
                m: Math.floor((diff % 3600000) / 60000),
                s: Math.floor((diff % 60000) / 1000)
            };
            el.querySelectorAll('.cd-num').forEach(numEl => {
                const unit = numEl.getAttribute('data-unit');
                const val = pad(units[unit]);
                if (numEl.textContent !== val) numEl.textContent = val;
            });
            const rafId = requestAnimationFrame(update);
            activeRafs.push(rafId);
        };
        update();
    });
}

registerPostRender(initCountdowns);
